import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentDevFlagsEffects } from './lib/tellent-dev-flags.effects';
import { TellentDevFlagsNamespace, TellentDevFlagsReducer } from './lib/tellent-dev-flags.store';
export { provideTellentDevFlags } from './lib/utils';

export * from './lib/tellent-dev-flags.store';
export * from './lib/tellent-dev-flags.http';

export { buildEmptyMap } from './lib/utils';

export const tellentDevFlagsData = [
  provideState(TellentDevFlagsNamespace, TellentDevFlagsReducer),
  provideEffects([TellentDevFlagsEffects]),
];

export { TellentDevFlagDataModule } from './lib/tellent-dev-flags.module';
